import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../firebase';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: 'auto', padding: 24 }}>
      <h2>Lupa Password</h2>
      {sent ? (
        <div style={{ color: 'green' }}>Link reset password telah dikirim ke email Anda.</div>
      ) : (
        <form onSubmit={handleReset}>
          <div>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{ width: '100%' }}
            />
          </div>
          {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
          <button type="submit" disabled={loading} style={{ marginTop: 16, width: '100%' }}>
            {loading ? 'Mengirim...' : 'Kirim Link Reset'}
          </button>
        </form>
      )}
    </div>
  );
};

export default ForgotPasswordPage;
